
import React from 'react';
import * as LucideIcons from 'lucide-react';
import { useTranslation } from 'react-i18next';

const UpcomingDrawCard = ({ nextDrawDate }) => {
  const { t } = useTranslation();
  const formattedDate = nextDrawDate ? new Date(nextDrawDate).toLocaleString() : 'TBD';

  return (
    <div className="bg-gradient-to-br from-purple-900/50 to-indigo-900/50 p-6 rounded-xl border border-purple-700/50 shadow-lg text-center mb-8 animate-fadeInUp">
      <LucideIcons.Calendar size={48} className="text-purple-300 mx-auto mb-4 animate-pulse-slow" />
      <h3 className="font-bold text-2xl text-purple-200 mb-2">{t('upcomingDrawCard.title')}</h3>
      <p className="text-xl text-white font-mono">{formattedDate}</p>
      <p className="text-sm text-gray-400 mt-2">{t('upcomingDrawCard.subtitle')}</p>
    </div>
  );
};

export default UpcomingDrawCard;
